import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsMenuComponent } from './settings-menu/settings-menu.component';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { SharedModule } from '@app/common/shared.module';
import { AdminModule } from '../admin/admin.module';

@NgModule({
  declarations: [SettingsMenuComponent],
  imports: [CommonModule, MenuModule, ButtonModule, SharedModule, AdminModule],
  exports: [SettingsMenuComponent],
})
export class SettingsModule {}
